
const View = ({ history, match, saludo, subtitulo }) => {
    return ('');
};

export { View };